<template>
  <div>
    <!--Main Header-->
    <div>
      <main-header />
    </div>
    <!--Admin panel-->
    <div class="columns">
      <!--Table-->
      <div class="column">
        <v-client-table :data="tableData" :columns="columns" :options="options">
          <div slot="Image" slot-scope="props" class="logo">
            <img
              class="logo"
              :src="'data:image/jpeg;base64,' + props.row.Image"
            />
          </div>
          <div slot="Name" slot-scope="props">
            <a @click="editManufacturer(props.row.ManufacturerID)">
              {{ props.row.Name }}
            </a>
          </div>
          <div slot="ManufacturerID" slot-scope="props">
            <a @click="editManufacturer(props.row.ManufacturerID)">
              {{ props.row.ManufacturerID }}
            </a>
          </div>
        </v-client-table>
      </div>
      <!--Edit panel-->
      <div class="column is-one-third">
        <!-- Create New and Delete buttons block -->
        <div class="columns">
          <!-- Create New button -->
          <div class="column">
            <button
              @click="createNewManufacturer"
              :disabled="isCreateNew || isEditExisting"
              class="button is-medium margin-bottom-20 margin-top-100"
            >
              Create New
            </button>
          </div>
          <!-- Delete button -->
          <div class="column">
            <button
              @click="deleteManufacturer"
              :disabled="isCreateNew || isInitial"
              class="button is-medium margin-bottom-20 margin-top-100 is-danger is-pulled-right"
            >
              Delete
            </button>
          </div>
        </div>
        <p class="is-size-7 mt-6">ManufacturerID</p>
        <input
          class="input is-size-7"
          v-model="selectedManufacturer.ManufacturerID"
          type="text"
          placeholder="ManufacturerID"
          :disabled="true"
        />
        <p class="is-size-7 mt-6">Name</p>
        <input
          class="input is-size-7"
          type="text"
          placeholder="Name"
          :disabled="isInitial"
          v-model="selectedManufacturer.Name"
        />
        <p class="is-size-7 mt-6">Country</p>
        <input
          class="input is-size-7"
          type="text"
          placeholder="Country"
          :disabled="isInitial"
          v-model="selectedManufacturer.Country"
        />
        <!-- image upload block -->
        <p class="is-size-7 mt-6">Image</p>
        <image-uploader
          ref="imageUploader"
          :isImagePresented="isImagePresented"
          :presentedImage="selectedManufacturer.Image"
          v-on:imageChanged="imageChanged"
          v-bind:is-disabled="isInitial"
          v-bind:external-status="currentStatus"
        />
        <!-- Save and Cancel buttons block -->
        <div class="columns margin-top-20">
          <!--Save button-->
          <div class="column">
            <button
              @click="saveButtonClicked"
              :disabled="isInitial"
              class="button"
            >
              Save
            </button>
          </div>
          <!--Cancel button-->
          <div class="column">
            <button
              @click="cancelButtonClicked"
              :disabled="isInitial"
              class="button is-pulled-right"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainHeader from "../MainHeader";
import ImageUploader from "../ImageUploader";

import { mapState } from "vuex";
import { Authorizer } from "../../auth/authorizer";
import { required } from "vuelidate/lib/validators";
// import { EditEnvironment } from "../../helpers/editEnvironment";

const STATUS_INITIAL = 0,
  STATUS_CREATE_NEW = 1,
  STATUS_EDIT_EXISTING = 2;

export default {
  name: "Manufacturers",
  components: { MainHeader, ImageUploader },

  data() {
    return {
      columns: ["ManufacturerID", "Name", "Country", "Image"],
      tableData: this.getData(),
      options: {
        // see the options API
      },
      selectedManufacturer: {
        Image: null,
      },
      currentStatus: null,
    };
  },

  validations: {
    selectedManufacturer: {
      Name: {
        required,
      },
    },
  },

  computed: {
    ...mapState(["allManufacturers"]),
    isImagePresented() {
      if (this.selectedManufacturer.Image !== null) {
        return true;
      }
      return false;
    },
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isCreateNew() {
      return this.currentStatus === STATUS_CREATE_NEW;
    },
    isEditExisting() {
      return this.currentStatus === STATUS_EDIT_EXISTING;
    },
  },

  methods: {
    getData() {
      console.log(this.$store.state.allManufacturers);
      return this.$store.state.allManufacturers;
    },
    getManufacturer(ManufacturerID) {
      let myManufacturer = this.$store.state.allManufacturers.filter(
        (x) => x.ManufacturerID === ManufacturerID
      )[0];
      return myManufacturer;
    },
    editManufacturer(ManufacturerID) {
      let myManufacturer = this.getManufacturer(ManufacturerID);
      this.selectedManufacturer = myManufacturer;
      this.currentStatus = STATUS_EDIT_EXISTING;
    },
    createNewManufacturer() {
      this.currentStatus = STATUS_CREATE_NEW;
      let newManufacturer = {
        Name: "",
        Country: "",
        Image: "",
        Items: [],
        ManufacturerSuppliers: [],
        ManufacturerTypes: [],
      };
      this.selectedManufacturer = newManufacturer;
    },
    imageChanged(data) {
      this.selectedManufacturer.Image = data;

      console.log(data);
    },
    async deleteManufacturer() {
      if (confirm("Do you reall want to delete?")) {
        let url = this.$store.state.deleteManufacturerUrl;
        var authorizer = new Authorizer(this.$auth, url);

        this.apiMessage = await authorizer.deleteManufacturer(
          this.selectedManufacturer
        );
        if (authorizer.errorMessage !== "") {
          // error
          alert(authorizer.errorMessage);
        } else {
          // OK
          console.log(authorizer.response.data);
          alert("sucessifully deleted!");
        }
        this.currentStatus = STATUS_INITIAL;
      }
    },
    async saveButtonClicked() {
      if (this.currentStatus === STATUS_CREATE_NEW) {
        let url = this.$store.state.createManufacturerUrl;
        var authorizer = new Authorizer(this.$auth, url);

        this.apiMessage = await authorizer.postManufacturer(
          this.selectedManufacturer
        );
        if (authorizer.errorMessage !== "") {
          // error
          alert(authorizer.errorMessage);
        } else {
          // OK
          // this.allManufacturers.push(authorizer.response.data);
          console.log(authorizer.response.data);
          alert("Successifully added!");
          // alert(authorizer.response.data.manufacturerId);
          this.currentStatus = STATUS_INITIAL;
        }
      } else if (this.currentStatus === STATUS_EDIT_EXISTING) {
        alert("Edit exisiting!");
      }
    },
    cancelButtonClicked() {
      this.currentStatus = STATUS_INITIAL;
      this.$refs.imageUploader.reset();
    },
  },
  created() {
    this.currentStatus = STATUS_INITIAL;
  },
};
</script>

<style scoped>
.logo {
  max-height: 20px;
  max-width: 80px;
}

.logo-big {
  max-height: 120px;
  max-width: 340px;
}

.margin-bottom-20 {
  margin-bottom: 20px;
}

.margin-top-20 {
  margin-top: 20px;
}

.margin-top-100 {
  margin-top: 100px;
}
</style>
